import React, {
  Suspense,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import * as router from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { Container } from 'react-bootstrap';

import BangGia from '../banggia';
import Assets from '../asset';
import Trading from '../trading';
import Cash from '../cash';
import Customer from '../customer';
import AnalysisMarket from '../market';

import { checkDefaultAuthorization } from '../../lib/check-auth';
import { getCategory, getSetting } from '../../lib/storages';
import { unsetClient } from '../client/actions';

import {
  allStockRequest,
  listMessageRequest,
} from '../banggia/actions';
import { logoutRequest } from '../../components/modal/login/actions';

import { configRequest } from '../client/actions';
import { Logout } from '../../components/modal/login/actions';

import Loading from '../../components/loading';
import Toast from '../../components/toast';

import * as _ from 'lodash';
import { WebSocketContext } from '../socket/webSocket';
import {
  makeGetToken,
  makeGetDefaultAccount,
  makeGetToast,
  makeGetConfig,
  makeGetNewOrder,
  makeGetCancelOrder,
  makeGetEditOrder,
  makeGetEventOrder,
  makeGetListAccount,
} from '../../lib/selector';

import { translate } from 'react-i18next';

const DefaultFooter = React.lazy(() => import('./DefaultFooter'));
const DefaultHeader = React.lazy(() => import('./DefaultHeader'));

const PrivateRoute = ({ component: Component, ...rest }) => {
  // console.log(rest)
  return (
    <router.Route
      {...rest}
      render={
        (props) => {
          checkDefaultAuthorization(rest.dispatch.store);
          return <Component {...props} store={rest.dispatch.store} />;
        }
        // checkDefaultAuthorization(rest.dispatch.store) === true ? (
        // <Component {...props} />
        // ) : (
        //   <router.Redirect
        //     to={{
        //       pathname: '/login',
        //     }}
        //   />
        // )
        //  )
      }
    />
  );
};

// Hook
function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function DefaultLayout(props) {
  const dispatch = useDispatch();
  const ws = useContext(WebSocketContext);
  // const as = React.useContext(AlgoSignalContext)

  const [toastList, setToastList] = useState([]);

  const prevToast = usePrevious(props.toast);
  const prevConfig = usePrevious(props.config);

  useEffect(() => {
    dispatch(configRequest());
    // dispatch(dmNganhRequest());

    const { token } = props;

    // if (!checkVersion()) {
    //   getCategory(props);
    //   getSetting(props);
    // } else {
      if (!token) {
        getCategory(props);
        getSetting(props);
      }
    // }
    _handleRequestListMessage();
  }, []);

  useEffect(() => {
    if (props.toast && props.toast.msg && !_.isEqual(props.toast, prevToast)) {
      const toastMsg = {
        title: props.toast.title,
        description: props.toast.msg,
      };
      showToast(toastMsg);
    }
  }, [props.toast]);

  useEffect(() => {
    if (
      props.configSuccessful &&
      props.config &&
      !_.isEqual(props.config, prevConfig)
    ) {
      if (props.config.code < 0) {
        // get setting localstorage
        getCategory(props);
        getSetting(props);
      } else {
        // TODO: get setting from server
        console.log(props.config)
        ws.init();
        // as.init()
      }

      dispatch(allStockRequest());
    }
  }, [props.configSuccessful, props.config]);

  const signOut = (e) => {
    e.preventDefault();
    _handleLogout();
  };

  const _handleLogout = () => {
    const { token } = props;
    if (token) dispatch(logoutRequest(token));

    dispatch(unsetClient());
    localStorage.removeItem('token');
    sessionStorage.removeItem('authen');

    dispatch(Logout());
  };

  const showToast = (toast) => {
    const id = Math.floor(Math.random() * 101 + 1);
    const toastProperties = {
      id,
      title: toast.title,
      description: toast.description,
    };
    // console.log(toastProperties)
    // return
    let _toastList = [...toastList, toastProperties];
    if (_toastList.length > 5) _toastList.shift();
    setToastList(_toastList);
  };

  const _handleRequestListMessage = () => {
    dispatch(listMessageRequest());
  };

  return (
    <>
      <Suspense fallback={<Loading />}>
        <DefaultHeader onLogout={(e) => signOut(e)} />
      </Suspense>
      <div className="app-body">
        <main className="main">
          <Container fluid>
            <Suspense fallback={<Loading />}>
              <router.Switch>
                <PrivateRoute
                  path="/home/bang-gia/:categoryId"
                  component={BangGia}
                  dispatch={props}
                />
                <PrivateRoute
                  path="/home/assets/:typeId"
                  component={Assets}
                  dispatch={props}
                  store={props}
                />
                <PrivateRoute
                  path="/home/trading/:typeId"
                  component={Trading}
                  dispatch={props}
                  store={props}
                />
                <PrivateRoute
                  path="/home/cash/:typeId"
                  component={Cash}
                  dispatch={props}
                  store={props}
                />
                <PrivateRoute
                  path="/home/customer/:typeId"
                  component={Customer}
                  dispatch={props}
                  store={props}
                />
                <PrivateRoute
                  path="/home/market/:typeId?"
                  component={AnalysisMarket}
                  dispatch={props}
                  store={props}
                />
                <router.Redirect
                  from="/home/assets"
                  to="/home/assets/tai-san"
                />
                <router.Redirect
                  from="/home/trading"
                  to="/home/trading/lenh-thuong"
                />
                <router.Redirect
                  from="/home/cash"
                  to="/home/cash/nap-rut-tien"
                />
                <router.Redirect
                  from="/home/customer"
                  to="/home/customer/ho-so"
                />
                <router.Redirect
                  from="/home/bang-gia"
                  to="/home/bang-gia/vn30"
                />
                <router.Redirect
                  from="/home/market"
                  to="/home/market/phan-tich-thi-truong"
                />
                <router.Redirect from="/bang-gia" to="/home/bang-gia/vn30" />
              </router.Switch>
            </Suspense>
          </Container>
        </main>
      </div>
      <Suspense fallback={<Loading />}>
        <DefaultFooter />
      </Suspense>
      <Toast
        toastList={toastList}
        position="top-right"
        autoDelete={true}
        dismissTime={4000}
      />
    </>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getToast = makeGetToast();
  const getConfig = makeGetConfig();
  const getNewOrder = makeGetNewOrder();
  const getCancelOrder = makeGetCancelOrder();
  const getEditOrder = makeGetEditOrder();
  const getListAccount = makeGetListAccount();
  const getDefaultAccount = makeGetDefaultAccount();
  const getEventOrder = makeGetEventOrder();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      toast: getToast(state),
      config: getConfig(state),
      defaultAccount: getDefaultAccount(state),
      listAccount: getListAccount(state),

      newOrder: getNewOrder(state),
      cancelOrder: getCancelOrder(state),
      editOrder: getEditOrder(state),

      event: getEventOrder(state),

      configSuccessful: state.client.configSuccessful,
      socketReady: state.socket.socketReady,
      serverStatus: state.socket.serverStatus,
      regPrivate: state.socket.regPrivate,
      regSym: state.socket.regSym,
      lang: state.client.setting.lang || 'vi',
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(DefaultLayout)
);
